import { ProductType } from '@tink/core/src/types';
import {
  GetRawParam,
  SomeValidatedCommonUrlParameters,
  ValidatedCommonUrlParameters,
} from '../utilities/urlParameters';
import { ERR_PARAM_AUTHORIZATION_CODE_INVALID } from '../utilities/error';
import { validateParams as validateParamsTransactions } from '../banking/transactions/urlParams';
import { validateParams as validateParamsBusinessTransactions } from '../banking/business-transactions/urlParams';
import { validateParams as validateParamsAccountCheck } from '../banking/account-check/urlParams';
import { validateParams as validateParamsProducts } from '../products/urlParams';
import { validateParams as validateParamsCredentials } from '../components/CredentialsDirector/urlParams';
import { ExtendConsentProduct } from '../models/product';

// Externally-visible signature
function assertUnreachable(value: never): never;
// Implementation signature
function assertUnreachable(value: string) {
  throw new Error(`Case ${value} not handled`);
}

export type ValidateExtendConsentParams = (
  commonParams: ValidatedCommonUrlParameters['parameters'],
  getRawParam: GetRawParam,
  productType: ExtendConsentProduct
) => SomeValidatedCommonUrlParameters;

export const validateParams: ValidateExtendConsentParams = (
  commonParameters,
  getRawParam,
  productType
) => {
  const { authorizationCode } = commonParameters;

  if (!authorizationCode) {
    return {
      parameters: { refreshableItems: [] },
      errors: [ERR_PARAM_AUTHORIZATION_CODE_INVALID],
    };
  }

  switch (productType) {
    case ProductType.TRANSACTIONS:
      return validateParamsTransactions(commonParameters, getRawParam);
    case ProductType.BUSINESS_TRANSACTIONS:
      return validateParamsBusinessTransactions(commonParameters, getRawParam);
    case ProductType.ACCOUNT_CHECK:
      return validateParamsAccountCheck(commonParameters, getRawParam);
    case ProductType.PRODUCTS:
      return validateParamsProducts(commonParameters, getRawParam);
    case ProductType.CREDENTIALS:
      return validateParamsCredentials(commonParameters, getRawParam);
    default:
      return assertUnreachable(productType);
  }
};
